import { Editor, useEditor } from '@tldraw/tldraw'
import { useLayoutEffect } from 'react'

// tldraw's built-in editing_shape tool state asserts getEditingShape() is non-null on pointer down, so if
// the shape being edited is deleted — or undone/redone away — while the editor stays in editing_shape, the
// id dangles and the next canvas click throws "Expected an editing shape!". Drop editing whenever the
// editing shape no longer resolves, so the editor falls back to select instead of crashing. The custom
// textBox editor makes this reachable (RichTextEditor re-enters editing via a synthetic pointer_down and
// only guards the keyboard-delete path).
export const exitEditingIfShapeMissing = (editor: Editor): void => {
  const id = editor.getEditingShapeId()
  if (id && !editor.getShape(id)) editor.setEditingShape(null)
}

// Registered on document changes (shape deletes and history removals are document-scope), NOT via
// sideEffects.registerAfterDeleteHandler — those don't fire during undo/redo, which is a path that hits
// this. setEditingShape(null) is an instance-scope write, so it can't re-trigger the document listener.
export const EditingShapeHandlers = () => {
  const editor = useEditor()

  useLayoutEffect(() => editor.store.listen(() => exitEditingIfShapeMissing(editor), { scope: 'document' }), [editor])

  return null
}
